import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import i18n, { detectInitialLanguage } from './i18n'
import { loadConfig, isI18nEnabled } from './shared/lib/config'

const rootElement = document.getElementById("root");
if (rootElement) {
  loadConfig()
    .then(async () => {
      // A deteccao de idioma so entra com a flag ligada, e antes do primeiro render para
      // nao piscar em pt-BR e trocar depois. Com a flag desligada o i18n fica no pt-BR da
      // init: navegador em outro idioma nao muda nada, que e o ponto da feature estar dark.
      if (isI18nEnabled()) {
        await i18n.changeLanguage(detectInitialLanguage());
      }
      createRoot(rootElement).render(<App />);
    })
    .catch((err) => {
      console.error('Failed to bootstrap application:', err);
      const msg = document.createElement('p');
      msg.style.padding = '2rem';
      msg.style.fontFamily = 'sans-serif';
      msg.style.color = '#c00';
      msg.textContent = 'Failed to load application configuration. Please refresh the page or contact support.';
      rootElement.replaceChildren(msg);
    });
}
